module.exports = __webpack_public_path__ + "img/bx-classroom-manage.f23e44d6.svg";